/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/ParseLines.ts
 * @create:      2025-07-01 18:00:11.492
 * @modify:      2025-07-11 21:19:12.943
 * @version:     6.0.0
 * @times:       4
 * @lines:       53
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ITextLines } from "../interface/ITextLines";
import { ParseEndOfLineSequence } from "./ParseEndOfLineSequence";
import { SplitStringByNewline } from "./SplitStringByNewline";

/**
 * Parses the given string data into an object containing the end-of-line sequence
 * and an array of lines split by newline characters.
 *
 * @param data - The input string to be parsed into lines.
 * @returns An `ITextLines` object with the detected end-of-line sequence and the array of lines.
 * 
 * @since 5.0.0
 * @version 2025-06-18
 */
export function ParseLines(data: string): ITextLines {
    return {
        endOfLineSequence: ParseEndOfLineSequence(data),
        lines: SplitStringByNewline(data),
    };
}
